// const Rectangle3Sided = (fabric) => {
//     console.log('Fabric-custome:', fabric)
//     fabric.ThreeSidedRectangle = fabric.util.createClass(fabric.Rect, {
//         type: 'ThreeSidedRectangle',

//         // initialize: function (options) {
//         //     options || (options = {});
//         //     this.callSuper('initialize', options);
//         // },

//         // toObject: function () {
//         //     return fabric.util.object.extend(this.callSuper('toObject'));
//         // },
//         initialize: function(options) {
//             options || (options = {});
//             this.callSuper('initialize', options);
//             this.width = options.width || 1;
//             this.height = options.height || 1;
//         },

//         toObject: function() {
//             return fabric.util.object.extend(this.callSuper('toObject'), {
//                 width: this.width,
//                 height: this.height
//             });
//         },

//         _render: function (ctx) {

//             if ((this.width === 0 && this.height === 0) || !this.visible) return
//             ctx.save();

//             // let scaleX = this.scaleX;
//             // let scaleY = this.scaleY;

//             ctx.strokeStyle = this.stroke;
//             ctx.lineWidth = this.strokeWidth;

//             ctx.beginPath();
//             ctx.moveTo(0, 0); // Start at top left
//             ctx.lineTo(0, this.height); // Draw down (left side)
//             ctx.lineTo(this.width, this.height); // Draw to the right (bottom side)
//             ctx.lineTo(this.width, 0); // Move up (top side is not drawn)
//             // Do not draw the right side
//             ctx.stroke();

//             ctx.restore();
//         },
//         setCoords: function() {
//             this.callSuper('setCoords');

//             this.aCoords = {
//                 tl: new fabric.Point(this.oCoords.tl.x, this.oCoords.tl.y),
//                 tr: new fabric.Point(this.oCoords.tr.x, this.oCoords.tr.y),
//                 bl: new fabric.Point(this.oCoords.bl.x, this.oCoords.bl.y),
//                 br: new fabric.Point(this.oCoords.br.x, this.oCoords.br.y)
//             };

//             // Custom logic to recalculate aCoords and oCoords
//             // This is just a placeholder; you'll need to implement the logic based on your specific requirements
//             // For example, you might want to recalculate the coordinates based on the current width, height, etc.

//             return this;
//         },

//         clipTo: function () {
//             var ctx = arguments[0]
//             this._render(ctx)
//         }
//     })

//     fabric.ThreeSidedRectangle.fromObject = function (object, callback) {
//         console.log('Object:', object)
//         callback && callback(new fabric.ThreeSidedRectangle( object));
//     };

//     fabric.ThreeSidedRectangle.async = true;
//     return fabric;
// }

// export default Rectangle3Sided

/********************* Without using Rect************************/

const Rectangle3Sided = (fabric) => {
    fabric.ThreeSidedRectangle = fabric.util.createClass(fabric.Object, {
        type: 'ThreeSidedRectangle',

        initialize: function (options) {
            options || (options = {})
            this.callSuper('initialize', options)

            this.width = options.width || 1
            this.height = options.height || 1

            this.lines = this._createLines()
        },

        _createLines: function () {
            // Create lines based on current width and height
            return [
                new fabric.Line([0, 0, this.width, 0], {
                    stroke: window.globalColor,
                    strokeWidth: 2
                }), // Top line
                new fabric.Line([this.width, 0, this.width, this.height], {
                    stroke: window.globalColor,
                    strokeWidth: 2
                }), // Right line
                new fabric.Line([this.width, this.height, 0, this.height], {
                    stroke: window.globalColor,
                    strokeWidth: 2
                }), // Bottom line
                new fabric.Line([0, this.height, 0, 0], {
                    stroke: window.globalColor,
                    strokeWidth: 2
                }) // Left line
            ]
        },
        toObject: function () {
            return fabric.util.object.extend(this.callSuper('toObject'), {
                width: this.width,
                height: this.height,
                lines: this.lines.map((line) => line.toObject())
            })
        },

        _render: function (ctx) {
            this.lines.forEach((line) => {
                line._render(ctx)
            })
        },
        setCoords: function () {
            this.callSuper('setCoords')

            const left = this.left
            const top = this.top
            const right = left + this.width
            const bottom = top + this.height

            // Update line positions
            this.lines[0].set({ x1: left, y1: top, x2: right, y2: top })
            this.lines[1].set({ x1: right, y1: top, x2: right, y2: bottom })
            this.lines[2].set({ x1: right, y1: bottom, x2: left, y2: bottom })
            this.lines[3].set({ x1: left, y1: bottom, x2: left, y2: top })

            this.lines.forEach((line) => line.setCoords())
            return this
        }

        // Implement other necessary methods and properties as needed
    })

    fabric.ThreeSidedRectangle.fromObject = function (object, callback) {
        callback && callback(new fabric.ThreeSidedRectangle(object))
    }
}

export default Rectangle3Sided
